import * as api from "./api";

export async function postDynamicFormData(data) {
  const result = await api.mediaPost(`form-data/create`, data);
  return result;
}
export async function updateDynamicFormData(data) {
  const result = await api.put(`form-data/update`, data);
  return result;
}
export async function getDynamicFormData(pageNum = "0", id) {
  const result = await api.get(
    `form-data?pageNum=${pageNum}${id ? `&id=${id}` : ""}`
  );
  return result;
}
export async function deleteDynamicFormData(id) {
  const result = await api.coreDelete(`form-data/delete?id=${id}`);
  return result;
}
export async function getDynamicFormList(formType = "") {
  const result = await api.get(`form-data/formName?formType=${formType}`);
  return result;
}
export async function addDynamicFormToEntityID(data) {
  const result = await api.mediaPost(`form-data/save`, data);
  return result;
}

export async function getFormByEntityId(entityId = "", entityType = "") {
  const result = await api.get(
    `form-data/response?entityId=${entityId}&entityType=${entityType}`
  );
  return result;
}
export async function saveFormResponse(data) {
  const result = await api.put(`form-data/update/savedData`, data);
  return result;
}
export async function getDynamicFormDataUnAuthorized(pageNum = "0", id) {
  const result = await api.unAuthorizedGetLoan(
    `form-data?pageNum=${pageNum}${id ? `&id=${id}` : ""}`
  );
  return result;
}
export async function getFormByEntityIdUnAuthorized(entityId = "") {
  const result = await api.unAuthorizedGetLoan(
    `form-data/response?entityId=${entityId}`
  );
  return result;
}
export async function saveFormResponseUnAuthorized(data) {
  const result = await api.unAuthorizedFormDataPut(
    `form-data/update/savedData`,
    data
  );
  return result;
}
export async function addDynamicFormToEntityIDUnAuthorized(data) {
  const result = await api.unAuthorizedPost(`form-data/save`, data);
  return result;
}
